import React, { useState } from "react";
import { CITIES } from "../mock";
import Reveal from "./Reveal";

const CitiesSection = () => {
  const [showAll, setShowAll] = useState(false);
  const shown = showAll ? CITIES : CITIES.slice(0, 40);
  return (
    <section className="py-14 bg-[#f7f9fc]">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 text-center">
        <Reveal>
          <h3 className="text-2xl font-bold text-navy font-head mb-6">
            Laundryma Serving <span className="text-orange-brand">92 Cities</span>
          </h3>
          <div className="flex flex-wrap justify-center gap-x-2 gap-y-3 text-sm">
            {shown.map((c, i) => (
              <React.Fragment key={c}>
                <a href="#" className="text-navy/60 hover:text-orange-brand transition-colors">{c}</a>
                {i < shown.length - 1 && <span className="text-gray-300">|</span>}
              </React.Fragment>
            ))}
          </div>
          <button onClick={() => setShowAll((v) => !v)} className="mt-6 text-orange-brand font-semibold text-sm hover:underline">
            {showAll ? "Show Less" : "View All Cities"}
          </button>
        </Reveal>
      </div>
    </section>
  );
};

export default CitiesSection;
